module.exports = __webpack_public_path__ + "static/newsweek-b8e32e9dabba3ce4be74fb50a406fe9d.png";